import { ActivityLabelConditionTypeEnum, ActivityLabelTargetEnum } from '@workalizer/shared/enums';
export var getAILabels = function () {
    return [
        {
            name: 'Team Collaboration Chats',
            rules: [
                {
                    target: ActivityLabelTargetEnum.CHAT_ROOM_NAMES,
                    conditions: [
                        {
                            type: ActivityLabelConditionTypeEnum.CONTAINS,
                            keyword: 'team'
                        },
                        {
                            type: ActivityLabelConditionTypeEnum.CONTAINS,
                            keyword: 'collaboration'
                        }
                    ]
                }
            ]
        },
        {
            name: 'Business Meetings',
            rules: [
                {
                    target: ActivityLabelTargetEnum.EVENT_NAMES,
                    conditions: [
                        {
                            type: ActivityLabelConditionTypeEnum.STARTS_WITH,
                            keyword: 'business'
                        },
                        {
                            type: ActivityLabelConditionTypeEnum.CONTAINS,
                            keyword: 'partners'
                        }
                    ]
                }
            ]
        },
        {
            name: 'Product Development',
            rules: [
                {
                    target: ActivityLabelTargetEnum.EVENT_NAMES,
                    conditions: [
                        {
                            type: ActivityLabelConditionTypeEnum.CONTAINS,
                            keyword: 'product'
                        },
                        {
                            type: ActivityLabelConditionTypeEnum.CONTAINS,
                            keyword: 'research'
                        }
                    ]
                }
            ]
        }
    ];
};
